var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 5.56918H2.77778C2.1555 5.56918 1.84436 5.56918 1.60668 5.69369C1.39761 5.8032 1.22763 5.97795 1.1211 6.19289C1 6.43724 1 6.75711 1 7.39686V19.7337C1 20.3734 1 20.6933 1.1211 20.9376C1.22763 21.1526 1.39761 21.3273 1.60668 21.4368C1.84436 21.5613 2.1555 21.5613 2.77778 21.5613H7.66667M7.66667 21.5613H14.3333M7.66667 21.5613L7.66667 2.82767C7.66667 2.18793 7.66667 1.86806 7.78777 1.6237C7.8943 1.40877 8.06428 1.23402 8.27334 1.1245C8.51102 1 8.82216 1 9.44444 1L12.5556 1C13.1778 1 13.489 1 13.7267 1.1245C13.9357 1.23402 14.1057 1.40877 14.2122 1.6237C14.3333 1.86806 14.3333 2.18793 14.3333 2.82767V21.5613M14.3333 10.1384H19.2222C19.8445 10.1384 20.1556 10.1384 20.3933 10.2629C20.6024 10.3724 20.7724 10.5471 20.8789 10.7621C21 11.0064 21 11.3263 21 11.966V19.7337C21 20.3734 21 20.6933 20.8789 20.9376C20.7724 21.1526 20.6024 21.3273 20.3933 21.4368C20.1556 21.5613 19.8445 21.5613 19.2222 21.5613H14.3333",
    stroke: "#F9F0FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingsIcon);
export default __webpack_public_path__ + "static/media/ratings_icon.8cbb93630a93f8ba7ea183671a6d3f83.svg";
export { ForwardRef as ReactComponent };